import { Box, InputLabel, TextField } from '@mui/material';
import { Controller, FieldValues, useWatch } from 'react-hook-form';

import { BaseInputProps } from './GetFormInput';

export function FormNumberInput<T extends FieldValues>({
    control,
    dependentField,
    disabled,
    fullWidth,
    helperText,
    label,
    required,
    small,
    validation,
    value,
}: Readonly<BaseInputProps<T>>) {
    const dependentFieldValue = useWatch({ control, name: dependentField ?? '' });
    const isDisabled = dependentField ? !dependentFieldValue : false;

    return (
        <Controller
            control={control}
            disabled={isDisabled}
            name={value}
            render={({ field: { onBlur, onChange, ref, value }, fieldState: { error } }) => (
                <Box>
                    <InputLabel sx={{ color: 'black', fontWeight: 'medium', mb: 0.5 }}>{label}</InputLabel>
                    <TextField
                        disabled={disabled ? disabled : isDisabled}
                        error={error?.message ? true : false}
                        fullWidth
                        helperText={error?.message ?? helperText}
                        onBlur={(e) => {
                            const newValue = Number.parseFloat(e.target.value);
                            if (!isNaN(newValue)) {
                                onChange(newValue);
                            }
                            onBlur();
                        }}
                        onChange={(e) => onChange(e.target.value)}
                        ref={ref}
                        required={required}
                        size={small ? 'small' : 'medium'}
                        sx={{ maxWidth: fullWidth ? undefined : 350 }}
                        type="number"
                        value={value ?? ''}
                        variant="outlined"
                    />
                </Box>
            )}
            rules={{
                required: required ? `${label ?? value} cannot be empty` : false,
                validate: (value) => {
                    if (value) {
                        const parsedValue = Number.parseFloat(value);
                        if (isNaN(parsedValue)) {
                            return 'Value must be a number';
                        }
                        const result = validation?.safeParse(parsedValue);
                        return result?.success ? true : result?.error.errors[0]?.message;
                    }
                },
            }}
        />
    );
}
